<template>
  <div class="view">
    <Title title="クイズセット"/>
    <QuizsetEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizsetEditMain from '@/components/Quizset/EditMain'

export default {
  components: {
    Title,
    QuizsetEditMain
  }
}
</script>
